import React from 'react';

import styled from 'styled-components';

import { Layout } from '@pkg/components/Sheet/components';

export const FiltersListToggleWrapper = styled.div`
    display: flex;
    justify-content: end;
`;

export const SheetLayout = styled((props) => <Layout {...props} />)`
    gap: unset;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 20px;
    }
`;
